import JwtService from "@/core/services/JwtService";
import { hasJwtToken } from "@/core/helpers/auth-token";

type RefreshFn = () => Promise<{ success?: boolean; data?: { token?: string } | null } | null>;

let refreshPromise: Promise<string | null> | null = null;

export async function refreshAccessTokenOnce(refreshFn: RefreshFn): Promise<string | null> {
  if (refreshPromise) return refreshPromise;

  refreshPromise = (async () => {
    try {
      if (!hasJwtToken(JwtService.getToken())) return null;
      const res = await refreshFn();
      if (res?.success && res.data?.token) {
        JwtService.saveToken(res.data.token);
        return res.data.token;
      }
      return null;
    } catch {
      return null;
    } finally {
      refreshPromise = null;
    }
  })();

  return refreshPromise;
}
